<template>
  <div
    class="audit-item"
    :class="{
      'active-item': selected,
      'show-keystage': showKeystage,
      'show-deadline': service
    }"
  >
    <div @click="selectAudit()" class="item-top">
      <p class="item-header">
        {{ plan.internalId ? 'C/YP ID' : 'Invision ID' }}:
        {{ plan.internalId || plan.ehcpId }}
      </p>
      <span class="assigned-to" :class="{ 'is-moderated': moderators }">
        <span class="number-badge">{{ moderators || '' }}</span>
        <i class="fas fa-user-friends"></i>
      </span>
    </div>
    <div @click="selectAudit()" class="item-container">
      <div class="item-detail">
        <div class="detail-property">
          {{ keyStagesText }}
        </div>
        <div class="detail-label">
          Upload Date:
        </div>
      </div>
      <div class="item-detail">
        <div class="detail-property">
          {{ plan.settingName }}
        </div>
        <div class="detail-property">
          {{ plan.createdAt | formatDate }}
        </div>
      </div>
    </div>
    <div class="item-service">

        <div v-if="(serviceOptions.length === 1)" class="single-service">
          <label>Health Report Written By:</label>
          <label  v-bind:key="opts.id" v-for="opts in serviceOptions">
            {{opts.service}}
          </label>
        </div>
        <div v-else class="multiple-service">
      <label
        >Health Report Written By:
        <select
          v-model="service"
          v-bind="{ disabled: !this.keystage }"
          v-on:change="changedService"
        >
          <option
            v-for="service in serviceOptions"
            v-bind:key="service.id"
            :value="service.id"
            >{{ service.service }}</option
          >
        </select></label
      >
    </div>
    </div>
    <div class="item-deadline">
      <span>Completion Deadline:</span>
      <input type="date" v-model="deadline" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'AuditSelectionItem',
  props: ['plan', 'bus', 'auditDeadline'],
  data() {
    return {
      selected: false,
      showKeystage: false,
      keystage: undefined,
      service: undefined
    }
  },
  computed: {
    deadline: {
      get() {
        return this.auditDeadline
      },
      set(value) {
        this.deadlineChanged(value)
      }
    },
    moderators() {
      return 0
    },
    keyStagesOptions() {
      return Object.keys(this.plan.stages)
    },
    serviceOptions() {
      if (!this.keystage) return []
      const serviceArr = []
      const services = this.plan.stages[this.keystage]
      services.forEach((ser, index) => {
        serviceArr.push({
          service: ser.service,
          id: ser.id
        })
      })
      const result = serviceArr
      return result
    },
    planKeystages() {
      return Object.keys(this.plan.stages)
    },
    keystageServices() {
      return this.plan.stages[this.keystage]
    },
    keyStagesText() {
      if (this.planKeystages.length === 1) {
        return this.planKeystages[0]
      } else {
        return 'Multiple Key stages'
      }
    }
  },
  methods: {
    selectAudit() {
      this.selected = !this.selected
      this.showKeystage = !this.showKeystage
      if (!this.selected) {
        // Unselect audit.
        if (this.service) this.$emit('audit-unselected', this.service)
      } else {
        // Preset if one keystage.
        if (this.planKeystages.length === 1) {
          this.keystage = this.planKeystages[0]
        }
      }
      if (this.serviceOptions.length === 1) {
        this.service = this.serviceOptions[0].id
        this.changedService()
      }

      // Clean up if we're closing.
      if (!this.showKeystage) {
        this.showKeystage = false
        this.keystage = undefined
        this.service = undefined
      }
    },
    changedService() {
      this.$emit('audit-selected', this.service)
    },
    deadlineChanged(e) {
      this.$emit('audit-deadline-changed', {
        plan: this.service,
        deadline: e
      })
    }
  },
  beforeMount() {
    this.bus.$on('reset', planId => {
      if (planId === this.plan._id) {
        this.showKeystage = false
        this.keystage = undefined
        this.service = undefined
      }
    })
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/variables.scss';

.audit-item {
  padding: 0 0.5rem;
  padding-top: 0.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.item-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.assigned-to {
  padding: 0 4px;
  color: $font-color-inactive;
  &.is-moderated {
    color: $font-color;
  }
}
.number-badge {
  padding-right: 0.25rem;
}

.item-header {
  text-transform: uppercase;
  font-size: 0.8rem;
  border-bottom: 1px solid rgab(0, 0, 0, 0.25);
  font-weight: 600;
}

.item-container {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  padding: 0.5rem 0;
}

.item-deadline {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
}

.item-deadline input {
  outline: none;
  line-height: 1.5rem;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 99px;
  font-size: 0.8rem;
  transition: border-radius 150ms ease-in-out;
  padding: 4px 8px;
}

.item-detail {
  display: grid;
  align-items: center;
  grid-template-columns: 1fr 1fr;
}
.detail-label {
  text-transform: uppercase;
  font-size: 0.75rem;
}
.detail-property {
  font-size: 0.75rem;
  margin-right: 1rem;
}

.audit-quarter {
  width: 100%;
  min-height: 48px;
  padding: 0.5rem 1rem;
}
.audit-quarter:hover {
  background: rgba(0, 0, 0, 0.1);
}

.list-heading {
  font-size: 0.75rem;
  line-height: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
  color: rgba(0, 0, 0, 0.7);
}

.list-content {
  font-size: 0.8rem;
  cursor: pointer;
}

.list-content:hover {
  text-decoration: underline;
}

.audit-items {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  margin: 0.25rem 0;
}

.audit-item:hover,
.active-item {
  cursor: pointer;
  color: white;
  background: $brand-gradient;
}

div.audit-item div.item-service {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}
div.audit-item div.item-service label {
  padding: 10px;
  flex-grow: 1;
}

div.audit-item div.item-service label select {
  outline: none;
  line-height: 1.5rem;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 99px;
  font-size: 0.8rem;
  transition: border-radius 150ms ease-in-out;
  padding: 4px 8px;
}

div.audit-item div.item-deadline {
  padding: 0 10px;
}

div.audit-item div.item-deadline,
div.audit-item div.item-service {
  max-height: 0;
  transition: max-height 0.2s ease-in-out;
  overflow: hidden;
}

div.audit-item.show-deadline div.item-deadline,
div.audit-item.show-keystage div.item-service {
  max-height: 40px;
}
div.single-service{
  display: flex;
}
div.single-service > label {
  color: #fff;
  margin: 0;
}

</style>
